import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import { makeStyles } from "@mui/styles";
import Box from "@mui/material/Box";
import cssClasses from "./ViewFOSDetails.module.css";
import Close from "../../Components/Icons/Close";
import Button from "../../Subcomponents/Button";
import { getAllFOSUnderCP } from "../../Services/ChannelPartner";
import { Card } from "@mui/material";
import EmptyListIcon from "../../Assets/Images/Common/EmptyListLeads.svg";


const useStyles = makeStyles((theme) => ({
  wrapperIcons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-around",
    marginBottom: "2rem",
    position: "relative",
  },
  closeIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "1.7rem",
    top: "1.7rem",
  },
  title: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.8rem",
    lineHeight: "2.8rem",
    color: "#101828",
    marginBottom: "0.8rem",
  },
  subTitle: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  wrapperButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "1.2rem",
  },
}));

export default function ViewFOSDetails({
  open,
  data,
  handleClose,
  loggedInUser,
  returnResp,
}) {
  const [fosList, setFosList] = useState([]);
  const [fosCount, setFosCount] = useState(0);
  const [fosPresent, setFosPresent] = useState(null);
  useEffect(() => {
    getFOSDetails();
  }, []);

  const classes = useStyles();
  function getFOSDetails() {
    getAllFOSUnderCP(data.cpId)
      .then((resp) => {
        console.log(resp);
        setFosList([...resp.data]);
        setFosCount(resp.count);
        if (resp.count === 0) {
          setFosPresent(false);
        } else {
          setFosPresent(true);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  function closeModal() {
    handleClose();
  }
  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          //   closeModal();
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(52, 64, 84, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    // button
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.wrapperContent}>
          <div className={cssClasses.header}>
            <div className={cssClasses.headerTitle}>FOS Details</div>
            <span
              className={classes.closeIcon}
              onClick={closeModal}
              tabIndex={0}
            >
              <Close width={"1.5rem"} height={"1.5rem"} />
            </span>
          </div>
          <div className={cssClasses.content}>
            <div className={cssClasses.count}>Total Fos:{fosCount}</div>
            {fosPresent && fosList.map((fos) => (
              <Card className={cssClasses.eventWrap} key={fos.fosId}>
                <div className={cssClasses.name}>{fos.name}</div>
                <div className={cssClasses.id}>
                  {" "} {'FOSID' + fos.fosDisplayId}
                  {/* {"FOSID" +
                    fos.fosDisplayId.replace(
                      fos.fosDisplayId.substring(8, 12),
                      "-" + fos.fosDisplayId.substring(8, 12)
                    )} */}
                </div>
                <div className={cssClasses.contactNumber}>
                  +{fos.contactNumber}
                </div>
              </Card>
            ))}
            {fosPresent === false && (
              <div className={cssClasses.noDataMsg}>
                <img src={EmptyListIcon} alt="No FoS" />
                <div className={cssClasses.emptyTitle}>
                  No FoS found Under CP {data.billingName}
                </div>
              </div>
            )}
          </div>
        </div>
      </Box>
    </Modal>
  );
}
